// @ vendors
const { pairs, clone, get } = require('lodash');

// @ actions
const {
    requestDataProprietor,
    requestSummaryDocumentation
} = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const { fetchEstatesData } = require('actions/mortgageRequest/mortgageRequestSimpleNote');
const notificationActions = require('actions/notifications');

// @ commons
const { APIPost, base64ToBlob, downloadAsFile } = require('utilities/APIRequestHelper');
const getExtension = require('utilities/mimeTypeToExt');

// @ constants
const fileNamesObject = require('constants/mortgageRequestFileNames');
const {
    MORTGAGE_REQUEST_ESTATES_DATA_FILES_LOADED,
    MORTGAGE_REQUEST_ESTATES_FETCH_DATA_REQUEST,
    MORTGAGE_REQUEST_FETCH_DOCUMENTATION_REQUEST,
    MORTGAGE_REQUEST_FETCH_DOCUMENTATION_SUCCESS,
    MORTGAGE_REQUEST_FETCH_DOCUMENTATION_FAILURE,
    MORTGAGE_REQUEST_DOCUMENTATION_RESET,
    MORTGAGE_REQUEST_OK_UPLOAD_BUTTON_INIT,
    MORTGAGE_REQUEST_OK_UPLOAD_BUTTON_SUCCESS,
    MORTGAGE_REQUEST_OK_UPLOAD_BUTTON_FAILURE,
    MORTGAGE_REQUEST_ESTATES_DATA_DOCUMENT
} = require('constants/actionTypes');

const { RECIB_HOGAR } = require('constants/mortgageRequestDocumentsTypes');

const requestEstatesDataLoaded = () => ({
    type: MORTGAGE_REQUEST_ESTATES_DATA_FILES_LOADED
});

const requestEstatesDataDocumentLoaded = response => ({
    type: MORTGAGE_REQUEST_ESTATES_DATA_DOCUMENT,
    documentData: { ...response }
})

const requestEstatesData = () => ({
    type: MORTGAGE_REQUEST_ESTATES_FETCH_DATA_REQUEST
});

const requestDocumentInProgress = (fileType) => ({
    type: MORTGAGE_REQUEST_FETCH_DOCUMENTATION_REQUEST,
    data: { fileType }
});

const requestDocumentSuccess = (fileType) => ({
    type: MORTGAGE_REQUEST_FETCH_DOCUMENTATION_SUCCESS,
    data: { fileType }
});

const requestDocumentFailure = (fileType, error) => ({
    type: MORTGAGE_REQUEST_FETCH_DOCUMENTATION_FAILURE,
    data: {
        fileType,
        error
    }
});

const requestDocumentReset = () => ({
    type: MORTGAGE_REQUEST_DOCUMENTATION_RESET
});

const requestUploadInit = (fileType, documentOrderNumber) => ({
    type: MORTGAGE_REQUEST_OK_UPLOAD_BUTTON_INIT,
    data: {
        fileType,
        documentOrderNumber
    }
});

const requestUploadSuccess = (fileType, data) => ({
    type: MORTGAGE_REQUEST_OK_UPLOAD_BUTTON_SUCCESS,
    data: {
        fileType,
        data
    }
});

const requestUploadFailure = (fileType, error) => ({
    type: MORTGAGE_REQUEST_OK_UPLOAD_BUTTON_FAILURE,
    data: {
        fileType,
        error
    }
});

const getEstatesData = (dispatch, getState) => !getState().mortgageRequestEstatesData.get('dataPanelRequested') && fetchEstatesData()(dispatch, getState);

const getSummaryDocumentation = (dispatch, getState) => {
    if (getState().mortgageRequestSummaryDocumentation.get('data').isEmpty()) {
        const idExpediente = getState().mortgageRequestState.get('idExpediente');
        const requestSummaryDocumentationAction = requestSummaryDocumentation(idExpediente)(dispatch, getState);

        requestSummaryDocumentationAction.then(() => getEstatesData(dispatch, getState));
    } else {
        getEstatesData(dispatch, getState);
    }
};

const getDataProprietorData = (dispatch, getState) => {
    if (getState().mortgageRequestDataProprietor.get('data').isEmpty()) {
        const requestDataProprietorAction = requestDataProprietor()(dispatch, getState);

        requestDataProprietorAction.then(() => getSummaryDocumentation(dispatch, getState));
    } else {
        getSummaryDocumentation(dispatch, getState)
    }
};

const getDocumentationData = () => (dispatch, getState) => getDataProprietorData(dispatch, getState);

const getFileName = fileType => {
    const fileNames = pairs(fileNamesObject);
    let fileName = fileNames.filter(
        ([item]) => item === fileType.replace(/\s+/g, '')
    ).map(fileName => fileName.pop());
    if (fileName.length === 0) {
        fileName = fileNamesObject.UNKNOWN;
    }
    return fileName;
};

const getNSDocuments = parametersNS => (dispatch, getState) => {
    parametersNS.idxDocument = parametersNS.idxDocument || 0;
    if (parametersNS.idxDocument === 0) {
        dispatch(requestEstatesData());
    }
    parametersNS.documentEstateId = parametersNS.documentEstatesId[parametersNS.idxDocument];
    //getDocument ya está definido cuando se ejecuta este código.
    //eslint-disable-next-line no-use-before-define
    getDocument(clone(parametersNS))(dispatch, getState);
};

const downloadDocument = (response, fileName) => {
    const base64string = `data:${response.data.contentType};base64,${response.data.base64}`;
    const fileExtension = getExtension(get(response, 'data.contentType', ''));
    const fileType = response.data.contentType;
    downloadAsFile(base64ToBlob(base64string), fileType, `${fileName}.${fileExtension}`);
};

const getDocument = parameters => (dispatch, getState) => {
    const idExpediente = getState().mortgageRequestState.get('idExpediente');

    let fileName = getFileName(parameters.documentType);
    let fileType = parameters.documentType;
    const idPrestamo = parameters.loanId ? parameters.loanId : parameters.idPrestamo;

    if (parameters.NSType) {
        fileName = `${fileName} - ${parameters.NSType}`;
        fileType = `${fileType}${parameters.NSType}`;
        if (typeof parameters.idxDocument === 'number') {
            fileName = `${fileName} - ${parameters.idxDocument}`;
            fileType = `${fileType}${parameters.idxDocument}`;
        }
    } else if (idPrestamo) {
        fileType = `${fileType}${idPrestamo}`;
    }

    const requestData = {
        query: {
            idExpediente,
            numeroDocumento: parameters.idDocumentNumber,
            tipoArchivo: parameters.documentType,
            tipoDocumento: parameters.idDocumentType,
            idPrestamo,
            mortgageDocumentId: parameters.documentId,
            mortgageOtherDocumentId: parameters.mortgageOtherDocumentId
        }
    };

    if (parameters.documentEstateId > 0) {
        requestData.query.bienId = parameters.documentEstateId;
    }

    dispatch(requestDocumentInProgress(fileType));

    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestDocumentsBase64Search',
        params: requestData
    }).then(response => {
        if (!parameters.notDownloadDocument)
            downloadDocument(response, fileName)

        dispatch(requestDocumentSuccess(fileType));

        if (typeof parameters.idxDocument === 'number') {
            parameters.idxDocument++;
            if (parameters.documentEstatesId && parameters.documentEstatesId.length > parameters.idxDocument) {
                getNSDocuments(clone(parameters))(dispatch, getState);
            } else {
                if (!parameters.notDownloadDocument)
                    dispatch(requestEstatesDataLoaded());
                else
                    dispatch(requestEstatesDataDocumentLoaded(response.data));
            }
        }
    }).catch(response => {
        if (!!response.error) {
            dispatch(requestDocumentFailure(fileType, response.error));
        } else {
            throw response;
        }
        if (typeof parameters.idxDocument === 'number') {
            parameters.idxDocument++;
            if (parameters.documentEstatesId && parameters.documentEstatesId.length > parameters.idxDocument) {
                getNSDocuments(clone(parameters))(dispatch, getState)
            } else {
                dispatch(requestEstatesDataLoaded());
            }
        }
    });
};

const resetState = () => dispatch => {
    dispatch(requestDocumentReset());
};

const uploadFile = (file, params, notificationMessage, documentOrderNumber) => (dispatch, getState) => {
    const idExpediente = getState().mortgageRequestState.get('idExpediente');
    const formData = new FormData();
    formData.append('files', file);
    let fileType = RECIB_HOGAR;

    let model = {
        tipoArchivo: fileType,
        idExpediente
    };

    if (params) {
        fileType = params.documentType;
        model = {
            comentarios: params.comments,
            tipoDocumento: params.idDocumentType,
            numeroDocumento: params.idDocumentNumber,
            tipoArchivo: fileType,
            bienId: params.documentEstateId,
            idPrestamo: params.loanId,
            mortgageDocumentId: params.documentId,
            mortgageOtherDocumentId: params.mortgageOtherDocumentId
        }
    }

    formData.append(
        'model',
        new Blob([
            JSON.stringify(model)
        ], {
                type: 'application/json'
            })
    );

    const requestData = { query: formData };

    dispatch(requestUploadInit(fileType, documentOrderNumber));
    return APIPost({
        dispatch,
        endpoint: 'mortgageRequesWorkDataFileMultipleSubmit',
        params: requestData,
        contentType: false
    })
        .then(response => {
            requestSummaryDocumentation(idExpediente)(dispatch, getState);
            dispatch(requestUploadSuccess(fileType, response));

            if (notificationMessage) {
                dispatch(notificationActions.success({ message: notificationMessage }, { voice: notificationMessage }));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(requestUploadFailure(fileType, response.error))
            } else {
                throw response;
            }
        });
}

module.exports = {
    getDocumentationData,
    getDocument,
    getNSDocuments,
    resetState,
    uploadFile
};
